import { render, staticRenderFns } from "./PersonaShowData.vue?vue&type=template&id=5720cfc8"
import script from "./PersonaShowData.vue?vue&type=script&lang=js"
export * from "./PersonaShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports